import React from 'react';
import PropTypes from 'prop-types';
import {withStyles} from '@material-ui/core/styles';
import TextField from '@material-ui/core/TextField';
import Input from '@material-ui/core/Input';
import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import FormControl from '@material-ui/core/FormControl';
import Select from '@material-ui/core/Select';
import FormLabel from '@material-ui/core/FormLabel';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import classNames from 'classnames';
import RadioGroup from '@material-ui/core/RadioGroup';
import Radio from '@material-ui/core/Radio';
import ReactSelect from 'react-select';
import jstimezonedetect from 'jstimezonedetect';
import isEqual from 'lodash/isEqual';
import isEmpty from 'lodash/isEmpty';
import InputAdornment from '@material-ui/core/InputAdornment';
import Visibility from '@material-ui/icons/Visibility';
import VisibilityOff from '@material-ui/icons/VisibilityOff';
import IconButton from '@material-ui/core/IconButton';

const timeBucketOptions = [
    {id: 1, value: 'minute', label: 'Minute'},
    {id: 2, value: 'hour', label: 'Hour'},
    {id: 3, value: 'day', label: 'Day'},
    {id: 4, value: 'week', label: 'Week'},
    {id: 5, value: 'month', label: 'Month'},
    {id: 6, value: 'quarter', label: 'Quarter'},
    {id: 7, value: 'halfYear', label: 'Half Year'},
    {id: 8, value: 'year', label: 'Year'},
    {id: 9, value: 'realTime', label: 'Real Time'}
];

const styles = theme => ({
    container: {
        display: 'flex',
        flexDirection: 'column',
        flexWrap: 'wrap',
        width: '100%'
    },
    textField: {
        width: '100%'
    },
    formControl: {
        marginTop: theme.spacing.unit,
        marginBottom: theme.spacing.unit,
        minWidth: 300
    },
    formControls: {
        textOverflow: 'ellipsis',
        overflow: 'hidden',
        width: '100%'
    },
    inputLabels: {
        fontSize: 12
    }
});

const timeBucketsStyles = {
    multiValueLabel: (styles, { data }) => ({
        ...styles,
        fontSize: 16
    })
};

class DefinitionControls extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            name: '',
            code: '',
            url: '',
            timeBuckets: this.setSelectedTimeBuckets([{id: 1}, {id: 2}, {id: 3}, {id: 4}, {id: 5}, {id: 6}]),
            editMode: true,
            groupId: null,
            status: 'active',
            timezone: '',
            timezones: [],
            securityToken: '',
            showSecurityToken: false
        };
    }

    componentWillReceiveProps(nextProps) {
        let newState = {...this.state};
        if (Object.keys(nextProps.editDataGroupParams).length !== 0 && ( 
                nextProps.editDataGroupParams.id !== this.state.groupId ||
                nextProps.editDataGroupParams.records !== this.state.records
            )) {
            this.setParameters(nextProps.editDataGroupParams, newState);
            newState.groupId = nextProps.editDataGroupParams.id;
        }

        if (Object.keys(nextProps.accountParameters).length !== 0) {
            this.setAccountParameters(nextProps.accountParameters, newState);
        }

        if (nextProps.timezones.length > 0) {
            this.setTimezones(nextProps.timezones, newState);
        }

        if(nextProps.editStatusProgramatically && nextProps.dataGroupStatus) {
            newState.status = nextProps.dataGroupStatus;
        }

        newState.editMode = nextProps.editDataGroupParams.editMode;
        this.setState(newState);
    }

    sendDatagroupParams = () => {
        this.props.paramsCallback({
            name: this.state.name,
            aggregationTimeBuckets: this.getSelectedTimeBuckets(),
            status: this.state.status,
            timezone: this.state.timezone,
            changedTimeBuckets: !this.areTimeBucketsEqual(),
            unsavedChanges: this.checkForUnsavedChanges(),
            url: this.state.url,

        });
    };

    checkForUnsavedChanges() {
        if(this.props.savedGroup !== null && typeof this.props.savedGroup !== 'undefined') {
            let savedGroup = this.props.savedGroup;
            return !isEqual(savedGroup.name, this.state.name) ||
                !isEqual(savedGroup.status, this.state.status) ||
                !isEqual(savedGroup.timezone, this.state.timezone) ||
                !this.areTimeBucketsEqual();
        }
    }

    areTimeBucketsEqual() {
        let first = this.props.savedGroup.aggregationTimeBuckets.map(a => a.id).sort();
        let second = this.getSelectedTimeBuckets().map(a => a.id).sort();
        return first.length === second.length && first.every((element, index)=> isEqual(element, second[index]));
    }

    handleChange = name => event => {
        this.setState({
            [name]: event.target.value
        });
    };

    handleTimeBucketsChange = name => value => {
        value.sort(function(a,b) {return a.id - b.id});
        this.setState({
            [name]: value
        });
    };

    getSelectedTimeBuckets() {
        let selected = [];
        if (this.state.timeBuckets !== null) {
            for (let obj of this.state.timeBuckets) {
                selected.push({
                    id: obj.id
                });
            }
        }
        return selected;
    }

    setSelectedTimeBuckets(selected) {
        let timeBuckets = [];
        for (let obj of selected) {
            let bucket = timeBucketOptions.find(option => {
                return option.id === obj.id;
            });
            timeBuckets.push(bucket);
        }
        timeBuckets.sort(function(a,b) {return a.id - b.id});

        return timeBuckets;
    }

    setParameters(params, newState) {
        if (Object.keys(params).length !== 0) {
            if (params.aggregationTimeBuckets !== null && typeof params.aggregationTimeBuckets !== 'undefined') {
                newState.timeBuckets = this.setSelectedTimeBuckets(params.aggregationTimeBuckets);
            }
            newState.name = params.name;
            newState.code = params.code;
            newState.url = newState.url + "/groups/" + params.code;
            newState.editMode = params.editMode;
            newState.status = params.status;
            newState.timezone = params.timezone;
            newState.records = params.records;
            newState.securityToken = params.securityKey;
        }
    }

    setAccountParameters(params, newState) {
        if (Object.keys(params).length !== 0) {
            newState.url = params.url + "/groups/" + newState.code;
        }
    }

    setTimezones(timezones, newState) {
        if (newState.timezone === '') {
            let timezoneName = jstimezonedetect.determine().name();
            let fullTimezoneName = timezones.find(zone => {
                return zone.includes(timezoneName)
            });
            newState.timezone = fullTimezoneName;
        }
        newState.timezones = timezones;
    }

    handleClickShowToken = () => {
        this.setState({ showSecurityToken: !this.state.showSecurityToken });
    };

    getRealTimeInputField = () => {
        if (this.state.timeBuckets.find(e => e.id === 9)) {
            return <TextField
                    required
                    id="realTimeInterval"
                    value={this.props.realTimeInterval}
                    label="Real Time Interval"
                    type="number"
                    style={{width: "20%", margin: "15px 0px"}}
                    onChange={event => this.props.handleRealTimeChange(event)}
                    disabled={this.state.editMode}
                    inputProps={{ min: "1", max: "20"}}/>
                    
        }
    }

    render() {
        const { editMode, records } = this.state;
        const { classes, editDataGroupParams } = this.props;

        this.sendDatagroupParams();

        return (
            <form className={classes.container} noValidate autoComplete="off">
                <TextField
                    required
                    id="name"
                    label="Name"
                    className={classes.textField}
                    value={this.state.name}
                    onChange={this.handleChange('name')}
                    margin="normal"
                    /*inputProps={{maxLength: 50}}*/
                />
                {!isEmpty(editDataGroupParams) ?
                    <div>
                        <div className="row" style={{display: 'flex',
                            'flexDirection': 'row'}}>
                            <div className="col-lg-3">
                                <TextField
                                    id="code"
                                    label="Code"
                                    value={this.state.code}
                                    className={classNames(classes.textField, 'disabled-text')}
                                    onChange={this.handleChange('code')}
                                    margin="normal"
                                    InputProps={{
                                        readOnly: true,
                                    }}
                                />
                            </div>
                            <div className="col-lg-9">
                                <TextField
                                    id="url"
                                    label="URL"
                                    value={this.state.url}
                                    className={classNames(classes.textField, 'disabled-text')}
                                    onChange={this.handleChange('url')}
                                    margin="normal"
                                    InputProps={{
                                        readOnly: true,
                                    }}
                                />
                            </div>
                        </div>
                        <br/>
                        <FormControl className={classNames(classes.margin, classes.textField)}>
                            <InputLabel htmlFor="adornment-password" shrink>Security Token</InputLabel>
                            <Input
                                id="adornment-password"
                                type={this.state.showSecurityToken ? 'text' : 'password'}
                                value={this.state.securityToken}
                                readOnly
                                className={classNames('disabled-text')}
                                onChange={this.handleChange('securityToken')}
                                endAdornment={
                                    <InputAdornment position="end">
                                        <IconButton
                                            aria-label="Toggle token visibility"
                                            onClick={this.handleClickShowToken}
                                        >
                                            {this.state.showSecurityToken ? <Visibility /> : <VisibilityOff />}
                                        </IconButton>
                                    </InputAdornment>
                                }
                            />
                        </FormControl>
                        <br/>
                        <FormLabel className={classes.inputLabels}>
                            Use the PUT HTTP method to submit data. To authenticate add "sectok: &lt;security token value&gt;" to the HTTP request header.
                        </FormLabel>
                    </div>
                    : null}
                <br/>
                <FormControl className={classes.formControl}>
                    <FormLabel className={classes.inputLabels}>Aggregation Time Buckets</FormLabel>
                    <ReactSelect
                        className={"basic-multi-select"}
                        classNamePrefix="select"
                        options={timeBucketOptions}
                        value={this.state.timeBuckets}
                        onChange={this.handleTimeBucketsChange('timeBuckets')}
                        isMulti
                        name="timeBuckets"
                        styles={timeBucketsStyles}
                        isDisabled={editMode}
                    />
                </FormControl>
                {this.getRealTimeInputField()}
                <div style={{width: '100%', marginTop: 15, marginBottom: 15}}>
                    <div className="row">
                        <div className="col-lg-6 col-sm-6">
                            <FormControl>
                                <FormLabel className={classes.inputLabels}>Data Group Status</FormLabel>
                                <RadioGroup
                                    row
                                    name="status"
                                    aria-label="status"
                                    value={this.state.status}
                                    onChange={this.handleChange('status')}
                                >
                                    <FormControlLabel value="active" control={<Radio />} label="Active"/>
                                    <FormControlLabel value="inactive" control={<Radio />} label="Inactive"/>
                                </RadioGroup>
                            </FormControl>
                        </div>
                        <div className="col-lg-6 col-sm-6">
                            <FormLabel className={classes.inputLabels}>Timezone</FormLabel>
                            <Select
                                className={classNames(classes.formControls)}
                                value={this.state.timezone}
                                onChange={this.handleChange('timezone')}
                                inputProps={{
                                    name: 'timezone',
                                    id: 'timezone',
                                }}
                                disabled={editMode}
                            >
                                {this.state.timezones.map((e, idx) => {
                                    return <MenuItem key={idx} value={e}>{e}</MenuItem>
                                })}
                            </Select>
                        </div>
                    </div>
                </div>
            </form>
        );
    }
}
DefinitionControls.propTypes = {
    classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(DefinitionControls);


// WEBPACK FOOTER //
// ./src/main/content/define-data-group/DefinitionControls.js